module.exports = require('../../full/array/is-array');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/features/array/is-array.js
// module id = 510
// module chunks = 0 1